export const AV_CENTER_AUDIT_LABELS = {
	staff_cancel: 'Cancel subscription',
	staff_portal_email: 'Send portal link',
	key_repush: 'Repush key',
	link_regenerate: 'Regenerate download link',
	purchase_av: 'Purchase AV',
	key_sold: 'Key Sold',
	mark_contacted: 'Mark contacted',
	resolve_removal: 'Resolve renewal removal',
	link_unmatched: 'Link unmatched Stripe',
	dismiss_unmatched: 'Dismiss unmatched Stripe',
	renewal_email_resend: 'Resend renewal email',
	outreach_notes: 'Outreach notes',
	removal_notes: 'Removal notes',
};

export const avCenterAuditLabel = (action) => AV_CENTER_AUDIT_LABELS[action] || action || '-';
